import { Localization } from "OW.Remoting/Remoting/Localization";
import { createElement } from "UI/UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";

/**
 * Vytvoří blokující vrstvu s informací o probíhajícím updatu aplikace
 * @includeToDoc
 */
export class UpdateProgressContentBuilder implements IContentBuilder {
    private _locKey: string;
    private _text: HTMLElement;
    private _loader: HTMLElement;

    constructor(locKey: string) {
        this._locKey = locKey;
    }

    public updateText(locKey: string): void {
        this._locKey = locKey;
        Localization.addLocTxtData(this._text, this._locKey);
    }
    public showLoader(): void {
        this._loader.setAttribute("data-lkd", "");
        this._loader.style.setProperty("visibility", "visible");
    }
    public hideLoader(): void {
        this._loader.style.visibility = "hidden";
    }

    public async build(): Promise<HTMLElement> {
        const wrapper = createElement({ classes: ["update-progress-content"] });
        const mainContent = createElement({ classes: "update-progress-content__wrapper" });
        this._loader = createElement({ classes: "update-progress-content__loader" });
        const content = createElement({ classes: "update-progress-content__content" });

        //const cardIcon = createElement({ classes: "update-progress-content__image" });
        //const svg = createElement({ type: "img", attrs: { src: "img/update.svg" } });
        //const img =  await fetch("img/update.svg");
        //if (img && img.text){
        //cardIcon.innerHTML = await img.text();}

        const squares = createElement({ classes: ["update-progress-content__squares"] });
        const squareBase = createElement({ classes: ["update-progress-content__square", "update-progress-content__square-base"] });
        const squareAni1 = createElement({ classes: ["update-progress-content__square", "update-progress-content__square-animated", "update-progress-content__square-animated--1"] });
        const squareAni2 = createElement({ classes: ["update-progress-content__square", "update-progress-content__square-animated", "update-progress-content__square-animated--2"] });
        this._text = createElement({ classes: [ "update-progress-content__title", "h3" ] });
        Localization.addLocTxtData(this._text, this._locKey);

        wrapper.appendChild(mainContent);
        mainContent.appendChild(content);

        content.appendChild(squares);
        squares.appendChild(squareBase);
        squareBase.appendChild(squareAni1);
        squareBase.appendChild(squareAni2);

        content.appendChild(this._text);

        return wrapper;
    }
}
